import React from 'react';
import styles from './PageError.module.scss';
import Button from 'common/components/Buttons/Button/Button';

const PageError = () => {
    const reloadPage = () => {
        location.reload();
    }
    return (
        <div className={styles.PageError}>
            <p>An unexpected error occurred.</p>
            <Button
                className={styles.PageErrorButton} 
                onClick={reloadPage}
                text='Refresh the page' />
        </div>
    );
};

export default PageError;